/* eslint-disable */
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useCategoryStore = defineStore('category', () => {
    const categoryDetails = ref({});
    const hardcodedCategories = [
        { img: '/images/thumbs/0025554_o-rings.jpeg', name: 'O-Rings', link: '/o-rings' },
        { img: '/images/thumbs/0025555_footer-cord.png', name: 'O-Ring Cord', link: '/o-ring-cord' },
        { img: '/images/thumbs/0025558_footer-kits.png', name: 'O-Ring Kits', link: '/o-ring-kits' },
        { img: '/images/thumbs/0025582_footer-vulcanized.png', name: 'Vulcanized O-Rings', link: '/vulcanized-o-rings' },
        { img: '/images/thumbs/0025556_footer-gasket.png', name: 'Flange Gaskets', link: '/flange-gaskets' },
        { img: '/images/thumbs/0025560_footer-spiral.png', name: 'Spiral Wound Gaskets', link: '/spiral-wound-gaskets' },
        { img: '/images/thumbs/0025644_footerconduit.png', name: 'Electrical Conduit Gaskets', link: '/electrical-conduit-gaskets' },
        { img: '/images/thumbs/0025557_footer-seals.png', name: 'Seals', link: '/seals' },
        { img: '/images/thumbs/0025580_footer-packing.png', name: 'Packing Material', link: '/packing-material' },
        { img: '/images/thumbs/0025552_footer-sheet.png', name: 'Sheet Material', link: '/sheet-material' },
        { img: '/images/thumbs/0025559_footer-accessories.png', name: 'Sealing Accessories', link: '/sealing-accessories' },
        { img: '/images/thumbs/0025549_footer-basic8.png', name: 'Basic 8 Cam & Groove', link: '/basic-8-cam-and-groove' },
        { img: '/images/thumbs/0025545_footer-dry_break.png', name: 'Dry Break', link: '/dry-break' },
        { img: '/images/thumbs/0025562_footer-military.png', name: 'Military Cam & Groove', link: '/military-cam-and-groove' },
        { img: '/images/thumbs/0025606_footer-sleeve.png', name: 'Sleeves & Ferrules', link: '/sleeves-and-ferrules' },
        { img: '/images/thumbs/0025588_footer-specialty.png', name: 'Specialty Cam & Groove', link: '/specialty-cam-and-groove' },
        { img: '/images/thumbs/0025561_footer-truck.png', name: 'Tank Truck & Railcar Fittings', link: '/tank-truck-and-railcar-fittings' },
        { img: '/images/thumbs/0025602_footer-nipple.png', name: 'Combination Nipples', link: '/combination-nipples' },
        { img: '/images/thumbs/0025563_footer-cam_accessories.png', name: 'Cam & Groove Accessories', link: '/cam-and-groove-accessories' },
        { img: '/images/thumbs/0025619_flatfooter.png', name: 'Flat Glass', link: '/flat-glass' },
        { img: '/images/thumbs/0025625_tubularfooter.png', name: 'Tubular Gauge Glass', link: '/tubular-gauge-glass' },
        { img: '/images/thumbs/0025627_annularfooter.png', name: 'Annular Glass', link: '/annular-glass' },
        { img: '/images/thumbs/0025636_reflexfooter.png', name: 'Flat Gauge Glass', link: '/flat-gauge-glass' },
        { img: '/images/thumbs/0025656_Gasket.png', name: 'Glass Accessories', link: '/glass-accessories' },
        { img: '/images/thumbs/0025565_footer-replacement.png', name: 'Replacement Visors', link: '/replacement-visors' },
        { img: '/images/thumbs/0025567_footer-headgear.png', name: 'PPE Headgear', link: '/ppe-headgear' },
        { img: '/images/thumbs/0025566_footer-sandblast.png', name: 'Sandblast Lenses', link: '/sandblast-lenses' },
        { img: '/images/thumbs/0025569_footer-blast.png', name: 'Blast Cabinet Underlayment', link: '/blast-cabinet-underlayment' },
        { img: '/images/thumbs/0025568_footer_respirator.png', name: 'Respirator Cover Lenses', link: '/respirator-cover-lenses' },
        { img: '/images/thumbs/0025555_footer-cord.png', name: 'O-Ring Cord', link: '/o-ring-cord' },
        { img: '/images/thumbs/0025580_footer-packing.png', name: 'Packing Material', link: '/packing-material' },
        { img: '/images/thumbs/0025552_footer-sheet.png', name: 'Sheet Material', link: '/sheet-material' },
        { img: '/images/thumbs/0025652_plasticfooter.png', name: 'Sheet Plastics', link: '/sheet-plastics' },
    ];


  async function loadAllCategoryDetails() {
    if (Object.keys(categoryDetails.value).length > 0) return
    // ideally this would be a call to the API to get all category details, from nopCommerce
    const categoryList = await Promise.resolve().then(() => hardcodedCategories) //todo: replace Promise with API call

    categoryList.forEach((category) => {
        const indexName = category.name.replace(/\s/g, '-').toLowerCase();
        categoryDetails.value[category.name] = category;
    })

  }

  return { loadAllCategoryDetails, categoryDetails };
});
